import { SettingsTemplatesPage } from '@/pages/settings-templates'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/templates/$template_id/')({
	component: SettingsTemplatesPage,
})
